module.exports = __webpack_public_path__ + "img/joven_tenista_bono.220b2982.jpg";